export const StrictEqualityComparer = (x, y) => x === y;
